import React from 'react';
import ReactDOM from 'react-dom';
import './theme.css';
import './index.css';
import { Capacitor } from '@capacitor/core';
import { BrowserRouter } from 'react-router-dom';
import MarketingPage from './components/pages/marketing/marketing_page';
import marketingData from './components/pages/marketing/marketing_data.json';
const App = React.lazy(() => import('./App'));
//import reportWebVitals from './reportWebVitals';

// iOS insets the web view above the home indicator itself (capacitor.config.json: contentInset
// "always"), so viewport-fit=cover would make env(safe-area-inset-*) pad those areas a second time.
// maximum-scale also stops iOS zooming in when a small-font input is focused.
if (Capacitor.getPlatform() === 'ios') {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0');
}

const rootElement = document.getElementById('root');
rootElement.style.height = '100%'

const blockedUiEvents = ['copy', 'cut', 'paste', 'selectstart', 'dragstart'];
const clipboardAllowedSelectors = ['.blog-page', '.field-notes-page', '.bt-marketing', '.not-found-page', '.public-recipe-container'];

const getEventElement = (target) => {
  if (target instanceof Element) {
    return target;
  }

  if (target && target.nodeType === Node.TEXT_NODE) {
    return target.parentElement;
  }

  return null;
};

const isClipboardAllowedArea = (target) => {
  const element = getEventElement(target);

  if (!element) {
    return false;
  }

  return clipboardAllowedSelectors.some((selector) => element.closest(selector));
};

blockedUiEvents.forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    const el = getEventElement(event.target);
    const isEditable =
      !!el &&
      (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);

    if (!isEditable && !isClipboardAllowedArea(event.target)) {
      event.preventDefault();
    }
  }, true);
});

// Public pages (/, /pricing, /compare/…, /field-notes/…) are prerendered to HTML at build time.
// Hydrate that markup instead of re-rendering it so the page does not flash or shift when the bundle arrives.
// They render without the lazy app bundle, so the Suspense fallback below never replaces their content.
const publicPath = window.location.pathname.replace(/\/$/, '') || '/';
const isWeb = Capacitor.getPlatform() === 'web';
const isMarketingPage = isWeb && !!marketingData.pages[publicPath];
const isFieldNotesPage = isWeb && /^\/field-notes(\/[a-z0-9-]+)?$/.test(publicPath);
const render = (isMarketingPage || isFieldNotesPage) && rootElement.hasChildNodes() ? ReactDOM.hydrate : ReactDOM.render;

// Shown while the app bundle loads (web private routes, and every native launch). Kept visually
// empty on the page background so it reads as the app starting, not as stray text.
const appLoading = <div className="app-loading" role="status"><span className="app-loading-label">Loading BiteTracker</span></div>;

const mount = (page) => render(<React.StrictMode>{page}</React.StrictMode>, rootElement);

if (isMarketingPage) {
  mount(<MarketingPage path={publicPath} />);
} else if (isFieldNotesPage) {
  // The prerendered article stays on screen while this chunk loads; hydration then attaches to it.
  import('./components/pages/field_notes/field_notes_routes').then(({ default: FieldNotesRoutes }) => {
    mount(<BrowserRouter><FieldNotesRoutes /></BrowserRouter>);
  });
} else {
  mount(<React.Suspense fallback={appLoading}><App /></React.Suspense>);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
